// src/App.js
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import RoutesConfig from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { CompetitionProvider } from './contexts/CompetitionContext';
import Header from './components/Common/Header';

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <CompetitionProvider>
          <Header />
          <RoutesConfig />
        </CompetitionProvider>
      </AuthProvider>
    </Router>
  )
};

export default App;
